import "./layout.scss"; // Factory layout read only
import "./index.scss";
import "./custom.scss";

import React, { Suspense, useEffect } from "react";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";

import { Routes as articleRoutes } from "./routes/article";
import { Routes as itemRoutes } from "./routes/item";
import { Routes as collectionRoutes } from "./routes/collection";
import { Routes as catalogueRoutes } from "./routes/catalogue";
import { Routes as legalRoutes } from "./routes/legal";
import { Routes as searchRoutes } from "./routes/search";
import { Routes as artistsRoutes } from "./routes/artists";
import { Routes as labelsRoutes } from "./routes/labels";
import { Route as verifyRoute } from "./routes/verify";
import { Route as unsubscribeRoute } from "./routes/unsubscribe";
import { Route as thankYouRoute } from "./routes/thankyou";
import { HomeWrapper } from "./routes/home";

import Maintenance from "./routes/maintenance";
import Header from "./components/header";
import Four0Four from "./routes/404";
import SuperHeader from "./components/superHeader";
import Menu from "./components/menu";
import { Store } from "./store";
import ConfigContext from "./configContext";
import CookiesComponent from "./components/cookies";
import Player from "./playerContext";
import SessionContext from "./sessionContext";
import CheckoutContext from "./checkoutContext";
import { ModalProvider } from "react-modal-hook";
import useAnalytics from "./hooks/useAnalytics";
import useResponsive from "./hooks/useResponsive";

export default function AppWrapper () {
  return (
    <>
      <ConfigContext>
        <SessionContext />
        <CheckoutContext>
          <Suspense fallback={<p></p>}>
            <App />
          </Suspense>
        </ CheckoutContext>
      </ConfigContext>
    </>
  );
}

const App = () => {
  const config = Store.useState(s => s.config);

  if (!config) return <h1 style={{ textAlign: "center", marginTop: "20%" }}></h1>;

  const settings = config.eshop?.theme?.selected?.settings;
  const homepage = config.eshop.preferences.homepage;

  const router = createBrowserRouter([
    {
      path: "/home",
      element: <HomeWrapper />
    },
    {
      path: "/",
      element: <Layout config={config} />,
      errorElement: <Error />,
      children: [
        ...catalogueRoutes(homepage),
        ...collectionRoutes(homepage),
        ...itemRoutes,
        ...legalRoutes,
        ...articleRoutes({ articles: config.articles, homepage }),
        ...searchRoutes,
        ...artistsRoutes,
        ...labelsRoutes,
        ...unsubscribeRoute,
        ...thankYouRoute,
        verifyRoute,
        {
          path: "*",
          element: <Four0Four />
        }
      ]
    }
  ]);

  return (
    <Maintenance config={config}>
      <div id="app" style={{ backgroundColor: `var(--${settings.backgroundColor?.id})` }}>
        <RouterProvider router={router} />
      </div>
    </Maintenance>
  );
};

const Layout = ({ config }) => {
  const settings = config.eshop?.theme?.selected?.settings;
  const { isMobile } = useResponsive({ maxWidth: config.eshop.theme.selected.settings?.mobileBreakpoint });

  useEffect(() => {
    Store.update(s => {
      s.isMobile = isMobile;
    });
  }, [isMobile]);

  return (
    <ModalProvider>
      <CookiesComponent />
      {settings.superHeader?.display ? <SuperHeader /> : <div /> }
      <Header />
      <Analytics />
      <div id="content" className={`${settings?.layout?.id || "centered"} ${isMobile ? "mobile" : ""}`}>
        <Menu location="navbar" layout={settings?.navbar?.layout.id} />
        <main style={{ gridArea: "main" }}>
          <Outlet />
        </main>
      </div>
      <Menu location="footer" />
      <Player />
    </ModalProvider>
  );
};

const Analytics = () => {
  useAnalytics();
  return null;
};

const Error = () => {
  return (
    <h1>Error</h1>
  );
};
